(ns web3.routers.app-handlers
  (:require [web3.view :as v]
            [web3.env :as env]
            [web3.components.html :as html]
            [web3.components.video :as video]
            [web3.screens.files :as files]
            [web3.screens.transfer :as transfer]
            [web3.screens.group :as group]
            [web3.screens.home :as home]
            [web3.screens.loading :as loading]
            [re-frame.core :as rf]
            [web3.routing.core :as routing]
            [re-frame-simple.db :as db]
            [web3.log :as log]
            [web3.i18n :as i]
            [web3.utils :as utils]
            [web3.screens.property :as property]
            [web3.screens.welcome :as welcome]
            [web3.screens.asset :as asset]
            [web3.screens.add :as add]
            [web3.screens.nameplate-locator :as nameplate-locator]
            [web3.screens.service-provider :as service-provider]
            [web3.screens.parent :as parent]
            [web3.screens.details :as details]
            [web3.lazy :as lazy]
            [web3.auth.api :as auth]
            [clojure.string :as str]
            [web3.routing.utils :as routing-utils]
            [web3.components.widgets :as w]
            ))

(defn TBD
  [message]
  (fn []
    [:div.text-center.pad-all-5.text-title "TBD - " message]))

(v/defview public-root
           {:allow-public true}
           []
           [:div])

(v/defview blank-root
           {:component-did-mount #(auth/start-flow :renew-softly)}
           []
           ;; blank root path should redirect to / when there is no form present
           (when-not (db/get-in [:db/routers :router/form-modal])
             (log/println "...blank-root view is redirecting to home, because there is no :form-modal view present")
             (routing/nav! (routing/path-for :router/root [:home])))

           [:div])
(defn get-param-value  [name]
  (nth (str/split name #"=") 1)
  )
(defn parse-params
  "Parse URL parameters into a hashmap"
  []
  (let [param-strs (-> (.-location js/window) (str/split #"\?") last (str/split #"\&"))]
    (into {} (for [[k v] (map #(str/split % #"=") param-strs)]
               [(keyword k) v]))))
;(defn- url-decode [encoded & [encoding]]
;  (java.net.URLDecoder/decode encoded (or encoding "UTF-8")))

;(def read-url-string (comp read-string url-decode))
(v/defview auth0-verify-email
           {:allow-public true }
           []
           (let [ qry-param (parse-params)
                 query (routing-utils/query  (.-location js/window))
                 clientID  (:clientID query)
                 appname (:appname query)
                 message (:message  query)
                 code (:code  query)
                 success (:success  query)
                 email (:email  query)
                 error-msg (if (= success "true" )
                             (str "Email verified successfully!")
                             (str "Email verification is Failed!")
                             )
                 ]

             (log/info "---- :query " query)

             [:div.flex.height-50p
              [:div.flex.flex-column.flex-auto.justify-center
               [:img {:src "/images/homeserve-logo-lowhouse.svg"
                      :style { :width "25%"
                              :margin-top 55
                              :margin-bottom 25
                              :margin-right "auto"
                              :margin-left "auto"}}]
               [:div.text-size-17.weight-medium.pad-all-3.text-center
                {:style {:text-shadow "0 0 10px rgba(255,255,255,1), 0 0 15px rgba(255,255,255,1), 0 0 30px rgba(255,255,255,1)"}}
                (str error-msg)
                [:br]
                (i/to-do  (str "Please click on the Sign-In to access the application" )  )
                ]
               ;[w/black-button
               ; {:href (routing/path-for [:welcome/add.property])
               ;  :class "text-white width-100p"}
               ; "Login" ]
               [:div.text-size-14.weight-medium.pad-all-3.text-center
                [:a
                 {:style {:cursor :pointer}
                  :on-click #(auth/logout!)}
                 ;{:href "/logout" }
                 (i/to-do "Sign-In")]
                ]
               ]]

             ))


(v/defview notification-page
           {:allow-public true }
           []
           (let [ qry-param (parse-params)
                 query (routing-utils/query  (.-location js/window))
                 registereduser  (:registereduser query)
                 error (:error query)
                 error_desc (:error_description  query)
                 ]
             ;(log/info "query"  (nth qry-param 1 )  )
             ;(doseq [[k vs] qry-param]
             ;     (println k vs)
             ;     (log/info "query"  k  vs )
             ;      )

             (log/info "---- :query " query)
             (log/info "---- :error"  error  )
             (log/info "---- :error_description"  error_desc  )
             (log/info "---- :registereduser"  registereduser )


             [:div.flex.height-50p
              [:div.flex.flex-column.flex-auto.justify-center
               [:img {:src "/images/homeserve-logo-lowhouse.svg"
                      :style { :width "25%"
                              :margin-top 55
                              :margin-bottom 25
                              :margin-right "auto"
                              :margin-left "auto"}}]
               [:div.text-size-17.weight-medium.pad-all-3.text-center
                {:style {:text-shadow "0 0 10px rgba(255,255,255,1), 0 0 15px rgba(255,255,255,1), 0 0 30px rgba(255,255,255,1)"}}
                (str "We've sent an email to " registereduser)
                [:br]
                (i/to-do  (str "Please check the email and complete the registration." )  )
                ]
               ;[w/black-button
               ; {:href (routing/path-for [:welcome/add.property])
               ;  :class "text-white width-100p"}
               ; "Login" ]
               [:div.text-size-14.weight-medium.pad-all-3.text-center
                [:a
                 {:style {:cursor :pointer}
                  :on-click #(auth/logout!)}
                 ;{:href "/logout" }
                 (i/to-do "Sign-In")]
                ]
               ;[:div.text-size-14.weight-medium.pad-all-3.text-center
               ; {:style {:cursor :pointer}
               ;  :on-click #(auth/logout!)}
               ; (i/to-do "Sign-In") ]

               ]]



             ;We've sent an email to <xxx@xxx.com>
             ;Please click in the email to complete the registration.
             ;If you do not receive an email. Please call customer service at 1-844-622-7063.
             ))

(v/defview log-out
           {:allow-public true
            :component-did-mount #(auth/logout!)}
           []
           [loading/loading-screen])

(def root (cond-> {:blank/public public-root
                   :blank/authed {:view blank-root
                                  :view/mode :mode/full-screen}

                   :home {:view home/screen
                          :view/mode :mode/nav-flexible}
                   :home/property {:view home/screen
                                   :view/mode :mode/nav-flexible}
                   :group group/screen

                   :property-transfer/accept.root transfer/accept-redirect

                   :files files/collection-picker
                   :files/collection files/collection

                   :video/youtube video/youtube
                   :static/html html/static-html
                   :loading (TBD "loading")

                   :authorize (constantly nil)              ;; placeholder view, never actually loaded

                   :logout log-out
                   :signup-complete notification-page
                   :auth0-verify-email auth0-verify-email}
                  env/devtools? (merge {:dev (lazy/loadable web3.screens.dev-samples/screen)})))

(def form-modal
  (-> {:modal/select-parent parent/select-parent
       :add-anything/start add/anything

       [:add/file
        :add-anything/file] add/collection-picker
       [:add/file-by-collection
        :add/file.collection
        :add-anything/file.collection] add/add-file-by-collection
       [:add/asset
        :add-anything/asset] add/asset-start
       [:add/asset.nameplate
        :add-anything/asset-by-nameplate] add/asset-by-nameplate
       [:add/asset.form
        :add-anything/asset-by-form] add/asset-by-manual-typing
       [:add/property
        :add-anything/property] property/add-zip
       [:add/group
        :add-anything/group] group/group-create
       [:add/service-provider
        :add-anything/service-provider] service-provider/add
       [:add/property.address
        :add-anything/property.address] property/add-address
       [:add/property.create-successful
        :add-anything/property.create-successful] property/create-successful

       :add/end-confirm add/add-end-confirm

       :welcome/start {:view welcome/start
                       :view/mode :mode/full-screen}
       :welcome/add.property {:view property/add-zip
                              :view/mode :mode/full-screen}
       :welcome/add.property.address {:view property/add-address
                                      :view/mode :mode/full-screen}
       :welcome/add.property.create-successful {:view property/add-address
                                                :view/mode :mode/full-screen}
       :welcome/get-mobile {:view welcome/get-mobile
                            :view/mode :mode/full-screen}

       :asset/nameplate-locator nameplate-locator/locator

       :asset/clarify add/asset-clarify
       :asset/recall-respond asset/asset-recall-respond
       :media/vimeo {:view welcome/vimeo-player
                     :view/mode :mode/full-screen}

       :property-transfer/create.start property/transfer-start
       :property-transfer/create.complete property/transfer-submitted
       :property-transfer/accept.start transfer/accept-start
       :property-transfer/accept.continue transfer/accept-continue
       :property/duplicate property/duplicate}

      (utils/flatten-keys)))

(def content-modal {:type/detail details/view})